<template>
  <div>
    <van-nav-bar :title="this.$route.query.title" fixed="fixed">
      <template #left>
        <div @click="$back(this)" class="backButton">
          <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>

    <div style="padding-top: 46px" v-if="this.url!==''">


      <iframe :src="this.url" class="content" :style="conHeight" align="right"></iframe>


    </div>

  </div>
</template>

<script>
export default {
  name: "advertisement",
  data() {
    return {
      conHeight: {
        height: '',
        url: ''
      }
    }
  },
  methods: {
    getHeight() {
      this.conHeight.height = window.innerHeight - 46 + 'px';
    },
    changeUrl() {
      let url = this.$route.query.url
      let index = url.indexOf('http')
      this.url = this.$route.query.url.slice(0, index + 4) + 's' + this.$route.query.url.slice(index + 4)
    }

  },
  created() {
    this.changeUrl();
    window.addEventListener('resize', this.getHeight);
    this.getHeight();
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  margin-bottom: 0;
  border: 0;
}

</style>
